import { Action } from 'shared/store/types';
import actionTypes from './actionTypes';
import { defaultState } from './constants';
import { AppState } from './types';

const app = (state = defaultState, action: Action): AppState => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.APP_REDUCER_SET_PAGE:
      return {
        ...state,
        pageType: payload,
      };

    case actionTypes.APP_REDUCER_STATUS_CODE:
      return {
        ...state,
        statusCode: payload,
      };

    case actionTypes.CONFIG_FLAGS:
      return {
        ...state,
        ...(payload && { configFlags: payload }),
        configFlagsFetched: true,
      };

    case actionTypes.GEO_SUBDIVISION:
      return {
        ...state,
        ...(payload && { geoSubdivision: payload }),
        geoSubdivisionFetched: true,
      };

    case actionTypes.SET_RUN: {
      return {
        ...state,
        run: payload,
      };
    }

    case actionTypes.SET_PATHNAME: {
      return {
        ...state,
        pathname: '',
      };
    }
    case actionTypes.SET_SIGNUP: {
      return {
        ...state,
        showSignUp: payload,
      };
    }
    case actionTypes.SET_LOGIN_AUTO_TRIGGERED: {
      return {
        ...state,
        isLoginAutoTriggered: payload,
      };
    }
    case actionTypes.TRUECALLER_STATUS_FETCHING:
      return {
        ...state,
        isTruecallerStatusFetching: true,
      };
    case actionTypes.TRUECALLER_STATUS_SUCCESS:
      return {
        ...state,
        isTruecallerStatusFetching: false,
      };
    case actionTypes.TRUECALLER_STATUS_FAILURE:
      return {
        ...state,
        isTruecallerStatusFetching: false,
      };
    case actionTypes.SET_PROFILE: {
      return {
        ...state,
        showProfile: payload,
      };
    }

    case actionTypes.SET_BACK_TO_TOP_POSITION: {
      return {
        ...state,
        backToTopPosition: payload,
      };
    }

    case actionTypes.UPDATE_CART_NUDGE_STATUS: {
      const { isVisible, position } = payload;
      return {
        ...state,
        showCartNudge: isVisible,
        cartNudgePosition: position,
      };
    }

    case actionTypes.UPDATE_APP_INSTALL_NUDGE_STATUS: {
      const { isVisible, position } = payload;
      return {
        ...state,
        showAppInstallNudge: isVisible,
        appInstallNudgePosition: position,
      };
    }

    default:
      return state;
  }
};

export default app;
